import { apiSlice } from "../apiSlice";

const FAV_URL = "/favourites";  

export const favouriteApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 🔹 Toggle favourite
    toggleFavourite: builder.mutation({
      query: (algorithmSlug) => ({
        url: `${FAV_URL}/toggle`,
        method: "POST",
        body: { algorithmSlug },
      }),
      invalidatesTags: ["Favourites"],
    }),

    // 🔹 Get all favourites
    getFavourites: builder.query({
      query: () => ({
        url: FAV_URL,
        method: "GET",
      }),
      providesTags: ["Favourites"],
    }),

    // 🔹 Check if specific algorithm is favourite
    checkFavourite: builder.query({
      query: (slug) => ({
        url: `${FAV_URL}/${slug}`,
        method: "GET",
      }),
      providesTags: ["Favourites"],
    }),
  }),
});

export const {
  useToggleFavouriteMutation,
  useGetFavouritesQuery,
  useCheckFavouriteQuery,
} = favouriteApiSlice;
